<template>
	<div>		<el-card class="box-card">
			<el-form :inline="true" :model="queryParams" class="demo-form-inline">
				<el-form-item label="手机号:">
					<el-input v-model="queryParams.memberMobile" placeholder="请输入手机号" clearable style="width: 150px;"></el-input>
				</el-form-item>
				<el-form-item label="运营商:" v-if="isAdmin">
					<el-select v-model="queryParams.distributorId" placeholder="请选择运营商" clearable filterable style="width: 180px;">
						<el-option v-for="item in distributorList" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="交易编号:">
					<el-input v-model="queryParams.tradeNo" placeholder="请输入交易编号" clearable style="width: 180px;"></el-input>
				</el-form-item>
				<el-form-item label="车辆编号:">
					<el-input v-model="queryParams.bicycleNumber" placeholder="请输入车辆编号" clearable style="width: 150px;"></el-input>
				</el-form-item>
				<el-form-item label="创建时间:">
					<el-date-picker v-model="dateRange" type="daterange" range-separator="-"
						start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
						value-format="yyyy-MM-dd" @change="handleDateChange">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleSearch" style="background-color: #3CA757; border-color: #3CA757;">查询</el-button>
					<el-button @click="resetQuery">重置</el-button>
				</el-form-item>
			</el-form>

			<el-table :data="orderList" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }" v-loading="loading">
				<el-table-column type="index" width="60"></el-table-column>
				<el-table-column prop="mobile" label="手机号" width="120"></el-table-column>
				<el-table-column prop="bicycleNumber" label="车辆编号" width="120"></el-table-column>
				<el-table-column prop="startTime" label="开始时间" width="160">
					<template slot-scope="scope">
						<span>{{ formatTime(scope.row.startTime) }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="endTime" label="结束时间" width="160">
					<template slot-scope="scope">
						<span>{{ formatTime(scope.row.endTime) }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="tripTimespan" label="骑行时长(分钟)" width="120"></el-table-column>
				<el-table-column prop="originalFee" label="骑行花费" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.originalFee">{{ scope.row.originalFee }}元</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column prop="premoney" label="押金" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.premoney">{{ scope.row.premoney }}元</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column prop="cashAmount" label="待支付金额(已支付)" width="150">
					<template slot-scope="scope">
						<span v-if="scope.row.cashAmount" style="color: #67C23A; font-weight: bold;">{{ scope.row.cashAmount }}元</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column prop="hasPaid" label="支付状态" width="100">
					<template slot-scope="scope">
						<el-tag type="success" size="small">已支付</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="payChannel" label="支付渠道" width="100">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.payChannel === 2" type="primary" size="small">银联支付</el-tag>
						<el-tag v-else type="success" size="small">微信支付</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="amount" label="可退金额" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.amount && scope.row.amount > 0" style="color: #E6A23C; font-weight: bold;">{{ scope.row.amount }}元</span>
						<span v-else style="color: #909399;">0元</span>
					</template>
				</el-table-column>
				<el-table-column prop="refundStatus" label="退款状态" width="100">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.refundStatus === 1" type="warning" size="small">已退款</el-tag>
						<el-tag v-else type="info" size="small">未退款</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="distributor" label="运营商" width="150"></el-table-column>
				<el-table-column prop="remark1" label="备注" width="150">
					<template slot-scope="scope">
						<span>{{ scope.row.remark1 || '-' }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="insertTime" label="创建时间" width="160">
					<template slot-scope="scope">
						<span>{{ formatTime(scope.row.insertTime) }}</span>
					</template>
				</el-table-column>
				<el-table-column fixed="right" header-align="center" align="center" width="180" label="操作">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" icon="el-icon-view"
							@click="handleView(scope.row)">详情</el-button>
						<el-button size="mini" type="warning" icon="el-icon-money"
							@click="handleRefund(scope.row)" v-if="scope.row.amount && scope.row.amount > 0">退款</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="queryParams.page" :page-sizes="[10, 20, 50, 100]"
				:page-size="queryParams.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</el-card>

		<el-dialog title="订单详情" :visible.sync="detailDialogVisible" width="600px">
			<el-descriptions :column="2" border>
				<el-descriptions-item label="交易编号">{{ currentOrder.tradeNo }}</el-descriptions-item>
				<el-descriptions-item label="用户名称">{{ currentOrder.memberName }}</el-descriptions-item>
				<el-descriptions-item label="手机号">{{ currentOrder.mobile }}</el-descriptions-item>
				<el-descriptions-item label="车辆编号">{{ currentOrder.bicycleNumber }}</el-descriptions-item>
				<el-descriptions-item label="车辆类型">
					<el-tag v-if="currentOrder.bicycleType === 1" type="success" size="small">自行车</el-tag>
					<el-tag v-else-if="currentOrder.bicycleType === 2" type="primary" size="small">电动车</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="骑行时长">{{ currentOrder.tripTimespan }}分钟</el-descriptions-item>
				<el-descriptions-item label="开始时间">{{ formatTime(currentOrder.startTime) }}</el-descriptions-item>
				<el-descriptions-item label="结束时间">{{ formatTime(currentOrder.endTime) }}</el-descriptions-item>
				<el-descriptions-item label="原价金额">{{ currentOrder.originalFee }}元</el-descriptions-item>
				<el-descriptions-item label="实付金额">{{ currentOrder.cashAmount }}元</el-descriptions-item>
				<el-descriptions-item label="押金">{{ currentOrder.premoney }}元</el-descriptions-item>
				<el-descriptions-item label="支付状态">
					<el-tag type="success" size="small">已支付</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="支付渠道">
					<el-tag v-if="currentOrder.payChannel === 2" type="primary" size="small">银联支付</el-tag>
					<el-tag v-else type="success" size="small">微信支付</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="可退金额">
					<span v-if="currentOrder.amount && currentOrder.amount > 0" style="color: #E6A23C; font-weight: bold;">{{ currentOrder.amount }}元</span>
					<span v-else style="color: #909399;">0元</span>
				</el-descriptions-item>
				<el-descriptions-item label="退款状态">
					<el-tag v-if="currentOrder.refundStatus === 1" type="warning" size="small">已退款</el-tag>
					<el-tag v-else type="info" size="small">未退款</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="已退金额" v-if="currentOrder.refundAmount">{{ currentOrder.refundAmount }}元</el-descriptions-item>
				<el-descriptions-item label="运营商">{{ currentOrder.distributor }}</el-descriptions-item>
				<el-descriptions-item label="创建时间">{{ formatTime(currentOrder.insertTime) }}</el-descriptions-item>
				<el-descriptions-item label="备注" :span="2">{{ currentOrder.remark1 || '-' }}</el-descriptions-item>
			</el-descriptions>
			<span slot="footer" class="dialog-footer">
				<el-button @click="detailDialogVisible = false">关 闭</el-button>
			</span>
		</el-dialog>

		<el-dialog title="订单退款" :visible.sync="refundDialogVisible" width="500px" @close="resetRefundForm">
			<el-form :model="refundForm" :rules="refundRules" ref="refundFormRef" label-width="100px">
				<el-form-item label="交易编号">
					<span>{{ refundForm.tradeNo }}</span>
				</el-form-item>
				<el-form-item label="手机号">
					<span>{{ refundForm.mobile }}</span>
				</el-form-item>
				<el-form-item label="车辆编号">
					<span>{{ refundForm.bicycleNumber }}</span>
				</el-form-item>
				<el-form-item label="实付金额">
					<span style="color: #67C23A; font-weight: bold;">{{ refundForm.cashAmount }}元</span>
				</el-form-item>
				<el-form-item label="可退金额">
					<span style="color: #E6A23C; font-weight: bold;">{{ refundForm.amount }}元</span>
				</el-form-item>
				<el-form-item label="已退金额" v-if="refundForm.refundAmount > 0">
					<span style="color: #F56C6C;">{{ refundForm.refundAmount }}元</span>
				</el-form-item>
				<el-form-item label="退款金额" prop="refundAmount">
					<el-input-number v-model="refundForm.inputRefundAmount" :min="0.01" :max="refundForm.amount" :precision="2" :step="0.1"
						style="width: 200px;"></el-input-number>
					<span style="margin-left: 10px; color: #909399;">元</span>
				</el-form-item>
				<el-alert title="退款金额不可超过可退金额" type="info" :closable="false" show-icon style="margin-bottom: 15px;"></el-alert>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="refundDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitRefund" :loading="refundLoading">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { getCurrentDistributorId } from '@/utils/distributor.js'

export default {
	data() {
		return {
			isAdmin: false,
			queryParams: {
				page: 1,
				limit: 10,
				memberMobile: '',
				distributorId: '',
				tradeNo: '',
				bicycleNumber: '',
				startDate: '',
				endDate: '',
				queryDistributorId: ''
			},
			dateRange: [],
			orderList: [],
			total: 0,
			loading: false,
			distributorList: [],
			detailDialogVisible: false,
			currentOrder: {},
			refundDialogVisible: false,
			refundLoading: false,
			refundForm: {
				id: '',
				tradeNo: '',
				mobile: '',
				bicycleNumber: '',
				cashAmount: 0,
				amount: 0,
				refundAmount: 0,
				inputRefundAmount: null
			},
			refundRules: {
				inputRefundAmount: [
					{ validator: this.validateRefundAmount, trigger: 'blur' }
				]
			}
		}
	},
	created() {
		this.isAdmin = window.sessionStorage.getItem('isAdmin') === 'true';
		this.getDistributorList();
		this.queryParams.queryDistributorId = getCurrentDistributorId()
		this.getOrderList();
		this.$root.$on('distributorChanged', this.handleDistributorChange)
	},
	beforeDestroy() {
		this.$root.$off('distributorChanged', this.handleDistributorChange)
	},
	methods: {
		validateRefundAmount(rule, value, callback) {
			if (value && value > this.refundForm.amount) {
				callback(new Error('退款金额不能超过可退金额'));
			} else if (value && value <= 0) {
				callback(new Error('退款金额必须大于0'));
			} else {
				callback();
			}
		},
		handleDistributorChange(distributorId) {
			this.queryParams.queryDistributorId = distributorId || ''
			this.queryParams.page = 1
			this.getOrderList()
		},
		getDistributorList() {
			this.$http.post('/distributor/manager/list', { page: 1, limit: 1000 }).then(res => {
				if (res.data.code === 200) {
					this.distributorList = res.data.data.list || [];
				}
			});
		},
		getOrderList() {
			this.loading = true;
			this.$http.post('/member/ridingOrder/paid/page', this.queryParams).then(res => {
				if (res.data.code === 200) {
					this.orderList = res.data.data.list;
					this.total = res.data.data.total;
				} else {
					this.$message.error(res.data.msg || '获取数据失败');
				}
				this.loading = false;
			}).catch(() => {
				this.loading = false;
			});
		},
		handleSearch() {
			this.queryParams.page = 1;
			this.getOrderList();
		},
		resetQuery() {
			this.queryParams = {
				page: 1,
				limit: 10,
				memberMobile: '',
				distributorId: '',
				tradeNo: '',
				bicycleNumber: '',
				startDate: '',
				endDate: '',
				queryDistributorId: getCurrentDistributorId()
			};
			this.dateRange = [];
			this.getOrderList();
		},
		handleDateChange(val) {
			if (val && val.length === 2) {
				this.queryParams.startDate = val[0];
				this.queryParams.endDate = val[1];
			} else {
				this.queryParams.startDate = '';
				this.queryParams.endDate = '';
			}
		},
		handleSizeChange(val) {
			this.queryParams.limit = val;
			this.getOrderList();
		},
		handleCurrentChange(val) {
			this.queryParams.page = val;
			this.getOrderList();
		},
		handleView(row) {
			this.currentOrder = row;
			this.detailDialogVisible = true;
		},
		handleRefund(row) {
			this.refundForm = {
				id: row.id,
				tradeNo: row.tradeNo,
				mobile: row.mobile,
				bicycleNumber: row.bicycleNumber,
				cashAmount: row.cashAmount,
				amount: row.amount,
				refundAmount: row.refundAmount || 0,
				inputRefundAmount: row.amount
			};
			this.refundDialogVisible = true;
		},
		resetRefundForm() {
			this.refundForm = {
				id: '',
				tradeNo: '',
				mobile: '',
				bicycleNumber: '',
				cashAmount: 0,
				amount: 0,
				refundAmount: 0,
				inputRefundAmount: null
			};
			if (this.$refs.refundFormRef) {
				this.$refs.refundFormRef.resetFields();
			}
		},
		submitRefund() {
			this.$refs.refundFormRef.validate(valid => {
				if (valid) {
					this.$confirm('确认退款 ' + this.refundForm.inputRefundAmount + ' 元吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.refundLoading = true;
						this.$http.post('/member/ridingOrder/refund', {
							id: this.refundForm.id,
							refundAmount: this.refundForm.inputRefundAmount
						}).then(res => {
							if (res.data.code === 200) {
								this.$message.success(res.data.data || '退款成功');
								this.refundDialogVisible = false;
								this.getOrderList();
							} else {
								this.$message.error(res.data.msg || '退款失败');
							}
							this.refundLoading = false;
						}).catch(() => {
							this.$message.error('请求失败');
							this.refundLoading = false;
						});
					}).catch(() => {
						this.$message.info('已取消退款');
					});
				}
			});
		},
		formatTime(time) {
			if (!time) return '-';
			const date = new Date(time);
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');
			const seconds = String(date.getSeconds()).padStart(2, '0');
			return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
		}
	}
}
</script>

<style scoped>
.el-card {
	margin-top: 20px;
}

.el-table {
	margin-top: 15px;
}

.el-pagination {
	margin-top: 20px;
}
</style>
